import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 24 24' fill='none'>
  <path d='M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z' fill={color}/>
</svg>
